import React from "react";

const LazyDropdownMenu = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { DropdownMenu } = await import("@radix-ui/react-dropdown-menu");

	return { default: DropdownMenu };
});

export type DropdownMenuProps = React.ComponentProps<typeof LazyDropdownMenu>;

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ children, ...props }) => (
	<React.Suspense fallback={children}>
		<LazyDropdownMenu modal={false} {...props}>
			{children}
		</LazyDropdownMenu>
	</React.Suspense>
);
